<template>
  <div class="d-flex align-center flex-column">
    <div class="_temp_list">
      <v-card flat rounded="lg" class="pa-4">
        <div class="d-flex px-2 align-start mb-2">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-bind="attrs"
                v-on="on"
                small
                @click="$router.go(-1)"
                icon
              >
                <v-icon color="#006341">mdi-reply</v-icon></v-btn
              >
            </template>
            <span>Back</span>
          </v-tooltip>
          <h3 class="mx-2">Managing Tanoto Future Leaders Business Acumen</h3>
        </div>
      </v-card>
      <div class="my-5 d-flex align-center justify-space-between">
        <h4>List Tanoto Future Leaders Business Acumen</h4>
        <v-btn class="btn" color="#016443">
          <h3 style="color: white; font-weight: normal" @click="exportData">
            Export Data
          </h3>
        </v-btn>
      </div>
      <div class="mt-4">
        <v-row no-gutters align="center">
          <v-col cols="12" md="5">
            <div class="ma-1 d-flex align-center">
              <v-icon class="mr-2"> mdi-text-search </v-icon>
              <v-text-field
                placeholder="Search"
                solo
                v-model="find"
                @keyup="fetchData"
                hide-details
                dense
                prepend-inner-icon="mdi-magnify"
                flat
                outlined
                color="#006341"
              ></v-text-field>
            </div>
          </v-col>
          <v-col cols="12" md="2">
            <div class="ma-1 d-flex justify-end">
              <v-btn
                depressed
                block
                color="#016443"
                @click="fetchData"
                dark
                class="text-capitalize"
              >
                Search
              </v-btn>
            </div>
          </v-col>
          <v-col
            cols="12"
            md="2"
            v-if="permissions.includes('ELSN') || role == 'SUPERADMIN'"
          >
            <div class="ma-1 d-flex justify-end">
              <v-btn
                depressed
                block
                color="#016443"
                @click="createData"
                dark
                class="text-capitalize"
              >
                <v-icon class="mr-2">mdi-plus-box</v-icon>
                Add
              </v-btn>
            </div>
          </v-col>
          <v-col
            cols="12"
            md="3"
            v-if="permissions.includes('ELSN') || role == 'SUPERADMIN'"
          >
            <div class="ma-1 d-flex justify-end">
              <v-btn
                depressed
                block
                color="#016443"
                to="/admin/msn/tanoto-ba/add-multiple"
                dark
                class="text-capitalize"
              >
                <v-icon class="mr-2">mdi-plus-box-multiple</v-icon>
                Add Multiple
              </v-btn>
            </div>
          </v-col>
        </v-row>
      </div>
      <div class="mt-3">
        <v-skeleton-loader
          class="my-5"
          type="table-tbody"
          v-if="loading"
        ></v-skeleton-loader>
        <div v-if="dataSet && !loading && dataSet">
          <v-data-table
            :headers="headers"
            :items="dataSet"
            :page.sync="page"
            :items-per-page="limit"
            class="elevation-0 color_txt"
            hide-default-footer
            :single-select="false"
            :item-class="row_classes"
          >
            <template v-slot:[`item.event_date`]="{ item }">
              {{ $date(item.event_date).format("DD, MMMM, YYYY") }}
            </template>
            <template v-slot:[`item.actions`]="{ item }">
              <div class="d-flex align-center justify-center">
                <v-btn
                  :disabled="
                    permissions.includes('ELSN') || role == 'SUPERADMIN'
                      ? false
                      : true
                  "
                  class="mr-2"
                  icon
                  @click="updateData(item)"
                >
                  <v-icon small>mdi-pencil</v-icon>
                </v-btn>
                <v-btn
                  :disabled="
                    permissions.includes('ELSN') || role == 'SUPERADMIN'
                      ? false
                      : true
                  "
                  icon
                  @click="deleteData(item)"
                >
                  <v-icon small color="red">mdi-delete</v-icon>
                </v-btn>
              </div>
            </template>
          </v-data-table>
        </div>
        <div class="text-center my-2 pa-3" v-if="dataSet">
          <v-pagination
            v-model="page"
            color="#006341"
            @input="fetchData"
            :length="last_page"
          ></v-pagination>
        </div>
        <div
          class="empty d-flex align-center justify-center flex-column"
          v-if="!dataSet && !loading"
        >
          <img
            src="../../../assets/img/redaksi/pagenotfound.png"
            height="250px"
            alt=""
          />
          <b class="default_txt my-3">Data not found</b>
        </div>
      </div>
    </div>
    <div class="pa-2">
      <dialog-large
        :d_large="d_large"
        @refetch="fetchData"
        @close="d_large = false"
        :inventory="inventory"
        :type="d_type"
        :title="d_title"
        line="true"
      />
      <dialog-small
        :d_small="d_small"
        @refetch="fetchData"
        @close="d_small = false"
        :inventory="inventory"
        :type="d_type"
        :title="d_title"
      />
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import dialogSmall from "../../dialog/dialogSmall.vue";
export default {
  components: { dialogSmall },
  name: "manageSn",
  computed: {
    ...mapState({
      permissions: (state) => state.permissions,
      role: (state) => state.role,
    }),
  },
  data() {
    return {
      loading: false,
      d_large: false,
      d_small: false,
      inventory: "",
      d_type: "",
      d_title: "",
      btnTitle: "",
      hide_title: "",
      dataSet: null,
      page: 1,
      limit: 10,
      find: "",
      headers: [
        {
          text: "TITLE",
          align: "center",
          value: "title",
        },
        {
          text: "Event Date",
          align: "center",
          value: "event_date",
          sortable: false,
        },

        {
          text: "Mitra TELADAN",
          align: "center",
          value: "vendor.name",
        },
        {
          text: "ACTION",
          align: "center",
          value: "actions",
          sortable: false,
        },
      ],
      form: [
        {
          label: "Title",
          type: "text",
          form: "title",
        },
        {
          label: "Description",
          type: "textarea",
          form: "description",
        },
        {
          label: "Event Date",
          type: "date",
          form: "event_date",
        },
        {
          label: "Financial Budget",
          type: "number",
          form: "budget",
        },
        {
          label: "Link Financial Budget",
          type: "text",
          form: "link_financial_budget",
        },
        {
          label: "Social Media",
          type: "text",
          form: "social_media",
        },
        {
          label: "Link SPK",
          type: "text",
          form: "link_spk",
        },
        {
          label: "Link TOR",
          type: "text",
          form: "link_tor",
        },
        {
          label: "Link Material",
          type: "text",
          form: "link_material",
        },
        {
          label: "Mitra TELADAN",
          type: "select",
          form: "sn_vendor_id",
        },
        {
          label: "Link Material",
          type: "text",
          form: "link_material",
        },
        {
          label: "Link Assignment",
          type: "text",
          form: "link_assignment",
        },
      ],
      listVendor: null,
    };
  },
  mounted() {
    this.fetchData();
    this.getVendor();
  },
  methods: {
    getVendor() {
      this.loading = true;
      let data = {
        path: `support/vendor`,
      };
      this.$store
        .dispatch("user/getUser", data)
        .then((data) => {
          this.loading = false;
          let mutating = data.data.map((el) => {
            return { id: el.id, name: el.name };
          });
          this.form.forEach((el) => {
            if (el.type == "select") {
              el["opt"] = mutating;
            }
          });
        })
        .catch((e) => {
          this.$store.dispatch("notify", {
            msg: e.message,
            type: "error",
          });
          this.loading = false;
        });
    },
    fetchData() {
      this.loading = true;
      let data = {
        path: `support/tanoto-ba?page[number]=${this.page}&page[size]=${this.limit}&filter[title]=${this.find}&sort=-created_at&include=vendor`,
      };
      this.$store
        .dispatch("user/getUser", data)
        .then((data) => {
          this.loading = false;
          this.dataSet = data.data;
          this.total = data.total;
          this.last_page = data.last_page;
        })
        .catch((e) => {
          this.$store.dispatch("notify", {
            msg: e.message,
            type: "error",
          });
          this.loading = false;
        });
    },
    exportData() {
      let data = {
        path: `support/tanoto-ba/export?filter[title]=${this.find}`,
        body: "",
      };
      this.$store
        .dispatch("user/getUser", data)
        .then((data) => {
          location.href = data.path;
        })
        .catch((e) => {
          this.$store.dispatch("notify", {
            msg: e.message,
            type: "error",
          });
        });
    },
    changeStep() {
      this.d_large = false;
      this.viewDetail(this.inventory.data, 2, "");
    },
    minStep() {
      this.d_large = false;
      this.viewDetail(this.inventory.data, 1, "");
    },
    createData() {
      this.inventory = {
        path: "support/tanoto-ba/create",
        body: {
          title: "",
          description: "",
          event_date: null,
          budget: "",
          link_financial_budget: "",
          social_media: "",
          link_spk: "",
          link_tor: "",
          link_material: "",
          sn_vendor_id: "",
          link_material: "",
          link_assignment: "",
        },
        form: this.form,
      };
      this.d_type = "c_businessAcument";
      this.d_title = "Add Data";
      this.d_large = true;
    },
    updateData(item) {
      this.inventory = {
        path: "support/tanoto-ba/update",
        body: {
          id: item.id,
          title: item.title,
          description: item.description,
          event_date: item.event_date,
          budget: item.budget,
          link_financial_budget: item.link_financial_budget,
          social_media: item.social_media,
          link_spk: item.link_spk,
          link_tor: item.link_tor,
          link_material: item.link_material,
          sn_vendor_id: item.sn_vendor_id,
          link_material: item.link_material,
          link_assignment: item.link_assignment,
        },
        form: this.form,
      };
      this.d_type = "c_businessAcument";
      this.d_title = "Update Data";
      this.d_large = true;
    },
    deleteData(item) {
      this.d_type = "d_businessAcument";
      this.d_title = "Delete Data";
      this.d_small = true;
      item["d_width"] = "300px";
      this.inventory = {
        path: "support/tanoto-ba/delete",
        id: item.id,
      };
    },
    row_classes(item) {
      let idx = this.dataSet.indexOf(item);
      if (idx % 2 == 0) {
        return "strip_"; //can also return multiple classes e.g ["orange","disabled"]
      }
    },
  },
};
</script>

<style></style>
